<template>
    <ul class="list no-flex">
    <checkout-base
        :components="components"
        :scroll-top-offset="scrollTopOffset"
        :scroll-duration="scrollDuration"
    >
        <template slot-scope="{ currentStep }">
            <div class="cart">

                <div class="sticky-progress-indicator">
                    <div class="my-constrained-container">
                        <span class="progress-step active uppercase" >1. {{ __('Kosár tartalma') }}</span>
                        <span
                            v-for="(component, index) in activeComponents"
                            :key="index"
                            class="progress-step"
                            :class="{ active: index < (currentStep)}">{{ index + 2 }}. {{ __(component + '-checkout-step') }}</span>
                    </div>
                </div>

                <cart v-if="currentStep < 3"/>

                <checkout-steps
                    :components="components"
                    :scroll-top-offset="scrollTopOffset"
                    :scroll-duration="scrollDuration"
                    :current-step="currentStep"
                />
            </div>
        </template>
    </checkout-base>
    </ul>
</template>

<script>
export default {
    props: {
        scrollTopOffset: {
            type: Number,
            default: () => {
                return 150
            }
        },
        scrollDuration: {
            type: Number,
            default: () => {
                return 500
            }
        },
        components: {
            type: Array,
            default: () => {
                return [
                    'authentication',
                    'shipping-mode',
                    'payment-mode',
                    'customer-data',
                    'summary-step'
                ]
            }
        }
    },

    data() {
        return {
            activeComponents: [],
            activeComponent: null,
        }
    },

    created() {
        this.$loading.show()

        this.$bus.$on('checkout-step-navigated', (componentsInfo) => {
            this.activeComponent = componentsInfo.to
        })

        this.$bus.$on('update-active-components', (components) => {
            this.activeComponents = components
        })
    },

    mounted() {
        this.unSub = this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'cart/update') {
                this.cartLoaded(state)
            }
        })
    },

    methods: {
        cartLoaded(state) {
            this.$loading.hide()

            const payload = {
                items: state.cart.items.map(
                    item => {
                        return {
                            id: item.id.identifier,
                            name: item.name,
                            quantity: item.quantity,
                            price: item.price.gross
                        }
                    }
                ),
                coupon: ''
            }
            gtag('event', 'begin_checkout', payload)
            this.unSub()
        }
    }
}
</script>
